var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-editions mb-4"},_vm._l((_vm.plugin.editions),function(edition,key){return _c('plugin-edition',{key:key,attrs:{"plugin":_vm.plugin,"edition":edition}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }